import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import "@/App.css";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { EditorialMarquee } from "./components/EditorialMarquee";
import { Services } from "./components/Services";
import { ProntoIntervento } from "./components/ProntoIntervento";
import { Brands } from "./components/Brands";
import { Process } from "./components/Process";
import { Trust } from "./components/Trust";
import { Zones } from "./components/Zones";
import { ContactForm } from "./components/ContactForm";
import { Footer } from "./components/Footer";
import { FloatingWhatsApp } from "./components/FloatingWhatsApp";
import { AdminPage } from "./components/AdminPage";
import { Seo } from "./components/Seo";

const Page = ({ title, description, children }) => (
  <div className="grain bg-[#07090D] text-[#F1F5F9] min-h-screen">
    <Seo title={title} description={description} />
    <Header />
    <main className="pt-16 md:pt-20">{children}</main>
    <Footer />
    <FloatingWhatsApp />
  </div>
);

function Home() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain bg-[#07090D] text-[#F1F5F9] min-h-screen">
      <Seo
        title="F&C Impianti — Assistenza Caldaie e Condizionatori a Domicilio | Roma"
        description="Assistenza caldaie e condizionatori a domicilio a Roma e provincia. Pronto intervento in giornata, manutenzione e installazione. Preventivo gratuito: 06 94806609."
      />
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <ProntoIntervento />
        <Trust />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/servizi" element={
            <Page title="Assistenza Caldaie e Condizionatori Roma | F&C Impianti"
              description="Riparazione, manutenzione e installazione caldaie e condizionatori a domicilio. Bollino, ricarica gas, sanificazione. Tecnici certificati F-Gas a Roma.">
              <Services />
            </Page>} />
          <Route path="/pronto-intervento" element={
            <Page title="Pronto Intervento Caldaie e Condizionatori Roma | F&C Impianti"
              description="Guasto alla caldaia o al condizionatore? Pronto intervento in giornata a Roma e provincia, 7 giorni su 7. Diritto di chiamata fisso 50€.">
              <ProntoIntervento asH1 />
            </Page>} />
          <Route path="/marche" element={
            <Page title="Marche Caldaie e Condizionatori Assistite | F&C Impianti"
              description="Assistiamo tutte le marche di caldaie e condizionatori: Vaillant, Baxi, Ariston, Daikin, Mitsubishi e molte altre. Ricambi originali, Roma e provincia.">
              <Brands />
            </Page>} />
          <Route path="/come-funziona" element={
            <Page title="Come Funziona l'Intervento a Domicilio | F&C Impianti"
              description="Tre passi semplici: ci contatti, fissiamo l'intervento con preventivo gratuito, risolviamo a casa tua. Assistenza caldaie e condizionatori a Roma.">
              <Process />
            </Page>} />
          <Route path="/zone" element={
            <Page title="Zone Coperte: Roma e Provincia | F&C Impianti"
              description="Interveniamo in tutti i quartieri di Roma e nei comuni della provincia: da Prati a Ostia, da Fiumicino a Tivoli. Trova la tua zona.">
              <Zones />
            </Page>} />
          <Route path="/contatti" element={
            <Page title="Contatti e Preventivo Gratuito | F&C Impianti Roma"
              description="Richiedi un preventivo gratuito per caldaia o condizionatore: modulo online, telefono 06 94806609 o WhatsApp. Ti ricontattiamo al più presto.">
              <ContactForm />
            </Page>} />
          <Route path="/admin" element={
            <>
              <Seo title="Area Riservata | F&C Impianti" description="Area riservata." noindex />
              <AdminPage />
            </>} />
        </Routes>
        <Toaster theme="dark" position="top-center" richColors />
      </BrowserRouter>
    </HelmetProvider>
  );
}
